
import { StringsMixin, BAIconsMixin, HelpInfoMixin } from '@/mixins';
import { Component, Prop, Mixins } from 'vue-property-decorator'

@Component
export default class RecruitingProfileInfo extends Mixins(StringsMixin, BAIconsMixin, HelpInfoMixin) {
	@Prop({ required: true }) label: string;
	@Prop({ type: String, default: undefined }) icon: string;
	@Prop({ required: true, default: undefined}) data: any;
	@Prop({ type: Boolean, default: true }) private dataCheck;
	@Prop({ type: Boolean }) noIcon;
	@Prop({ type: Boolean }) noLabel;								// do not display the label if data is available
	@Prop({ type: Boolean }) always;
	@Prop({ default: "6" }) labelCols: string;
	@Prop({ default: "0" }) appendCols: string;
	@Prop({ type: Boolean }) link;
	@Prop({ type: Boolean }) large;
	@Prop({ type: Boolean }) dense;
	@Prop({ type: Boolean }) infoButton;
	@Prop({ type: Boolean }) wrap;
	@Prop({ type: Boolean }) clipboard;
	@Prop({ type: String, default: undefined}) email: string;

	get DisplayRecruitingProfileInfo(): boolean {
		return this.DisplayData || this.showHelp;
	}
	get DisplayData(): boolean {
		if( this.always ) return true;
		if( this.HasEmail ) return true;
		return this.HasData && this.dataCheck;
	}
	get DisplayLabel(): boolean {
		if( this.noLabel ) return this.showHelp && (this.data === "not shared");
		if( this.IsEmpty(this.label) ) return false;
		return this.DisplayData;
	}

	get Data(): string {
		if( typeof(this.data) === 'string' ) return this.data;
		if( typeof(this.data) === 'boolean' ) return this.data? 'true':'false';
		if( typeof(this.data) === 'number' ) return this.data.toString();
		if( this.data instanceof Date ) return this.formatDatePretty(this.data);
		if( this.data instanceof Array ) return this.data.toString();
		return typeof(this.data);
	}
	get HasData(): boolean {
		return this.IsNotEmpty(this.data);
	}
	get HasEmail(): boolean {
		return this.IsNotEmpty(this.email);
	}
}
